/* addon-bundler.js
 * Blind Barrels — Subscription + Add-ons bundler
 * v3.3: annual / quarterly / one-time + per-plan discount + image swap + cart-first
 *       + "free sample requires subscription" config export for cart guard
 */


(function () {
  const SECTION_SELECTOR = '[data-subscription-toggle]';
  const TOGGLE_BTN_SELECTOR = '[data-plan-toggle]';
  const CTA_SELECTOR = '[data-plan-cta]';
  const SAMPLE_LINK_SELECTOR = '[data-sample-link]';
  const PLAN_CONTENT_SELECTOR = '[data-plan-content]';
  const PLAN_IMAGE_SELECTOR = '[data-plan-image]';
  const PLAN_IMAGE_MOBILE_SELECTOR = '[data-plan-image-mobile]';

  const q = (sel, root = document) => root.querySelector(sel);
  const qa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const toNum = (val) => {
    if (val == null || val === '') return null;
    const n = Number(val);
    return Number.isFinite(n) ? n : null;
  };

  async function addItems(items) {
    if (!items || !items.length) return;

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(text || `Add to cart failed: ${res.status}`);
    }

    return res.json();
  }

  function tryOpenCartDrawer() {
    const triggerSelectors = [
      'button[aria-controls*="CartDrawer"]',
      '[data-drawer-id*="cart"]',
      '.js-toggle-cart',
      '.header__icon--cart, .site-header__cart',
      'button[name="open-cart"], a[href="#cart-drawer"]',
      'a[href="/cart"]'
    ];
    for (const sel of triggerSelectors) {
      const el = document.querySelector(sel);
      if (el) {
        el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        return true;
      }
    }
    return false;
  }

  function handlePostAddRedirect(mode, discountCode) {
    const normalized = (mode || 'cart').toLowerCase();

    switch (normalized) {
      case 'checkout': {
        let url = '/checkout';
        if (discountCode) {
          url = '/checkout?discount=' + encodeURIComponent(discountCode);
        }
        window.location.assign(url);
        break;
      }
      case 'drawer': {
        const opened = tryOpenCartDrawer();
        if (!opened) window.location.assign('/cart');
        break;
      }
      case 'cart': {
        let url = '/cart';
        if (discountCode) {
          url = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart';
        }
        window.location.assign(url);
        break;
      }
      default:
        window.location.assign('/cart');
        break;
    }
  }

  function setActivePlan(sectionEl, plan) {
    qa(TOGGLE_BTN_SELECTOR, sectionEl).forEach((btn) => {
      const isActive = btn.getAttribute('data-plan-toggle') === plan;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', String(isActive));
    });

    qa(PLAN_CONTENT_SELECTOR, sectionEl).forEach((card) => {
      const isActive = card.getAttribute('data-plan-content') === plan;
      card.classList.toggle('d-none', !isActive);
    });

    swapPlanImage(sectionEl, plan);
  }

  function getActivePlan(sectionEl) {
    const activeCard = qa(PLAN_CONTENT_SELECTOR, sectionEl).find(
      (el) => !el.classList.contains('d-none')
    );
    if (activeCard) return activeCard.getAttribute('data-plan-content');

    const activeBtn = qa(TOGGLE_BTN_SELECTOR, sectionEl).find((b) =>
      b.classList.contains('is-active')
    );
    return activeBtn ? activeBtn.getAttribute('data-plan-toggle') : 'annual';
  }

function swapPlanImage(sectionEl, plan) {
  const desktopImg = q(PLAN_IMAGE_SELECTOR, sectionEl);
  const mobileImg = q(PLAN_IMAGE_MOBILE_SELECTOR, sectionEl);

  // Desktop image (same behavior as before)
  if (desktopImg) {
    const annualSrc    = desktopImg.getAttribute('data-annual-image') || '';
    const quarterlySrc = desktopImg.getAttribute('data-quarterly-image') || '';
    const onetimeSrc   = desktopImg.getAttribute('data-onetime-image') || '';
    const fallbackSrc  = desktopImg.getAttribute('data-fallback-image') || '';

    let nextDesktopSrc = '';

    if (plan === 'annual') {
      nextDesktopSrc = annualSrc || fallbackSrc;
    } else if (plan === 'quarterly') {
      nextDesktopSrc = quarterlySrc || fallbackSrc;
    } else if (plan === 'onetime') {
      nextDesktopSrc = onetimeSrc || fallbackSrc;
    } else {
      nextDesktopSrc = fallbackSrc || annualSrc || quarterlySrc || onetimeSrc;
    }

    if (nextDesktopSrc && desktopImg.src !== nextDesktopSrc) {
      desktopImg.src = nextDesktopSrc;
    }
  }

  // Mobile image (per-plan, optional)
  if (mobileImg) {
    const annualMobileSrc    = mobileImg.getAttribute('data-annual-mobile-image') || '';
    const quarterlyMobileSrc = mobileImg.getAttribute('data-quarterly-mobile-image') || '';
    const onetimeMobileSrc   = mobileImg.getAttribute('data-onetime-mobile-image') || '';
    const fallbackMobileSrc  = mobileImg.getAttribute('data-mobile-fallback-image') || '';

    let nextMobileSrc = '';

    if (plan === 'annual') {
      nextMobileSrc = annualMobileSrc || fallbackMobileSrc;
    } else if (plan === 'quarterly') {
      nextMobileSrc = quarterlyMobileSrc || fallbackMobileSrc;
    } else if (plan === 'onetime') {
      nextMobileSrc = onetimeMobileSrc || fallbackMobileSrc;
    } else {
      nextMobileSrc = fallbackMobileSrc || annualMobileSrc || quarterlyMobileSrc || onetimeMobileSrc;
    }

    if (nextMobileSrc && mobileImg.src !== nextMobileSrc) {
      mobileImg.src = nextMobileSrc;
    }
  }
}


function buildItemsForPlan(sectionEl, plan) {
  const ds = sectionEl.dataset;
  const ids = {
    annualVariant:    toNum(ds.annualVariant),
    annualPlan:       toNum(ds.annualPlan),
    quarterlyVariant: toNum(ds.quarterlyVariant),
    quarterlyPlan:    toNum(ds.quarterlyPlan),
    annualGlasses:    toNum(ds.annualGlasses),
    quarterlyGlass:   toNum(ds.quarterlyGlass),
    includedSample:   toNum(ds.includedSample),
    oneTimeSample:    toNum(ds.oneTimeSample)
  };

  const items = [];

  if (plan === 'annual') {
    if (!ids.annualVariant || !ids.annualPlan) {
      throw new Error('Annual plan is not configured: missing variant or selling plan ID.');
    }

    // Annual subscription line item – THIS is what Bold/Shopify uses as the subscription
    items.push({
      id: ids.annualVariant,
      quantity: 1,
      selling_plan: ids.annualPlan,
      properties: {
        "_bb_included": "yes",
        "_bb_plan_type": "annual"
      }
    });

    // Free 4-glass set (normal line item, no selling plan)
    if (ids.annualGlasses) {
      items.push({
        id: ids.annualGlasses,
        quantity: 1,
        properties: {
          "_bb_included": "yes",
          "_bb_parent_plan": "annual"
        }
      });
    }

    // 5th Bonus Kit (sample) – included only for annual
    if (ids.includedSample) {
      items.push({
        id: ids.includedSample,
        quantity: 1,
        properties: {
          "_bb_included": "yes",
          "_bb_parent_plan": "annual"
        }
      });
    }
  } else if (plan === 'quarterly') {
    if (!ids.quarterlyVariant || !ids.quarterlyPlan) {
      throw new Error('Quarterly plan is not configured: missing variant or selling plan ID.');
    }

    // Quarterly subscription line item
    items.push({
      id: ids.quarterlyVariant,
      quantity: 1,
      selling_plan: ids.quarterlyPlan,
      properties: {
        "_bb_included": "yes",
        "_bb_plan_type": "quarterly"
      }
    });

    // Free quarterly glass (if configured)
    if (ids.quarterlyGlass) {
      items.push({
        id: ids.quarterlyGlass,
        quantity: 1,
        properties: {
          "_bb_included": "yes",
          "_bb_parent_plan": "quarterly"
        }
      });
    }
  } else if (plan === 'onetime') {
    // One-time paid kit only – no selling plan
    if (!ids.oneTimeSample) {
      throw new Error('One-time plan is not configured: missing one-time sample variant ID.');
    }

    items.push({
      id: ids.oneTimeSample,
      quantity: 1,
      properties: {
        "_bb_included": "yes",
        "_bb_plan_type": "onetime"
      }
    });
  } else {
    throw new Error('Unknown plan: ' + plan);
  }

  return items;
}

  /**
   * Export config for the cart-sample-guard into localStorage.
   * This pulls everything from the section's data-* attributes (which
   * are bound to section.settings in the theme editor).
   */
  function storeGuardConfigFromSection(sectionEl) {
    if (!sectionEl || typeof window === 'undefined' || !window.localStorage) return;

    try {
      const ds = sectionEl.dataset;

      // Free sample + paid fallback
      const freeSampleVariantId = toNum(ds.includedSample);
      const paidSampleVariantId = toNum(ds.sampleFallback);

      // Subscription variants
      const subAnnual = toNum(ds.annualVariant);
      const subQuarterly = toNum(ds.quarterlyVariant);
      const subscriptionVariantIds = [subAnnual, subQuarterly].filter(Boolean);

      // Included glasses (annual + quarterly) – optional but we’ll use them if present
      const freeGlassAnnual = toNum(ds.annualGlasses);
      const freeGlassQuarterly = toNum(ds.quarterlyGlass);
      const freeGlassVariantIds = [freeGlassAnnual, freeGlassQuarterly].filter(Boolean);

      if (!freeSampleVariantId || !paidSampleVariantId || !subscriptionVariantIds.length) {
        // Not fully configured yet – bail out quietly
        return;
      }

      const cfg = {
        freeSampleVariantId,
        paidSampleVariantId,
        subscriptionVariantIds,
        freeGlassVariantIds
      };

      window.localStorage.setItem('bbGuardConfig', JSON.stringify(cfg));
    } catch (e) {
      console.error('[addon-bundler] unable to store cart guard config:', e);
    }
  }

  function bindSection(sectionEl) {
    if (!sectionEl) return;

    // As soon as we see a configured section, export its config for the cart guard.
    storeGuardConfigFromSection(sectionEl);

    // Toggle clicks
    qa(TOGGLE_BTN_SELECTOR, sectionEl).forEach((btn) => {
      btn.addEventListener('click', () => {
        const plan = btn.getAttribute('data-plan-toggle');
        setActivePlan(sectionEl, plan);
      });
    });

    // CTA (Add to cart) clicks
    qa(CTA_SELECTOR, sectionEl).forEach((cta) => {
      cta.addEventListener('click', async (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        const plan = getActivePlan(sectionEl);
        const ds = sectionEl.dataset;

        let redirectMode = ds.redirectAfterAdd || 'cart';
        if (plan === 'annual' && ds.redirectAnnual) {
          redirectMode = ds.redirectAnnual;
        } else if (plan === 'quarterly' && ds.redirectQuarterly) {
          redirectMode = ds.redirectQuarterly;
        } else if (plan === 'onetime' && ds.redirectOnetime) {
          redirectMode = ds.redirectOnetime;
        }

        let discountCode = '';
        if (plan === 'annual' && ds.annualDiscount) {
          discountCode = ds.annualDiscount;
        } else if (plan === 'quarterly' && ds.quarterlyDiscount) {
          discountCode = ds.quarterlyDiscount;
        } else if (plan === 'onetime' && ds.onetimeDiscount) {
          discountCode = ds.onetimeDiscount;
        }

        cta.disabled = true;
        cta.setAttribute('aria-busy', 'true');

        try {
          const items = buildItemsForPlan(sectionEl, plan);
          if (!items.length) throw new Error('No items to add for the selected plan.');

          await addItems(items);

          handlePostAddRedirect(redirectMode, discountCode);
        } catch (err) {
          console.error('[addon-bundler] CTA error:', err);
          alert(
            err && err.message
              ? err.message
              : 'Sorry—something went wrong adding your selection. Please refresh and try again.'
          );
        } finally {
          cta.disabled = false;
          cta.removeAttribute('aria-busy');
        }
      });
    });

    // Optional: direct sample-box link (if you use it anywhere)
    const sampleBtn = q(SAMPLE_LINK_SELECTOR, sectionEl);
    if (sampleBtn) {
      sampleBtn.addEventListener('click', async (ev) => {
        ev.preventDefault();
        const ds = sectionEl.dataset;
        const sampleVariant = toNum(ds.oneTimeSample);
        const fallbackUrl = ds.oneTimeSampleUrl || '';
        try {
          if (sampleVariant) {
            await addItems([{ id: sampleVariant, quantity: 1 }]);
            const opened = tryOpenCartDrawer();
            if (!opened) window.location.assign('/cart');
          } else if (fallbackUrl) {
            window.location.assign(fallbackUrl);
          } else {
            alert('Sample box not available right now.');
          }
        } catch (err) {
          console.error('[addon-bundler] Sample add error:', err);
          alert('Could not add the sample box. Please try again.');
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    qa(SECTION_SELECTOR).forEach((sectionEl) => {
      bindSection(sectionEl);
      setActivePlan(sectionEl, 'annual');
    });
  });
})();
